import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({ src, alt, className, containerClassName, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={`relative overflow-hidden bg-gray-200 dark:bg-white/5 ${containerClassName || ''}`}>
      {/* Loading Placeholder (Blur Effect) */}
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 z-10 flex items-center justify-center backdrop-blur-md bg-gray-200/50 dark:bg-gray-800/50 animate-pulse">
          {/* Optional: Add a subtle logo or spinner here if needed */}
        </div>
      )}

      {/* Error State */}
      {hasError && (
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center bg-gray-100 dark:bg-surface-dark text-gray-400">
          <ImageOff size={24} className="mb-2 opacity-50" />
          <span className="text-[10px] uppercase font-bold tracking-wider">Görsel Yok</span>
        </div>
      )}

      <img
        src={src}
        alt={alt}
        className={`transition-all duration-700 ease-out ${className || ''} ${isLoaded ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-105 blur-lg'
          }`}
        onLoad={() => setIsLoaded(true)}
        onError={() => {
          setIsLoaded(true);
          setHasError(true);
        }}
        {...props}
        loading="lazy"
      />
    </div>
  );
};